module.exports = __webpack_public_path__ + "images/bannerIT-e0b7237f7675cf68de248170073a25ea.png";